export const CONTEXT = 'deposits';
export const ROBINSON = 'ROBINSON';
export const NO_ROBINSON = 'NO_ROBINSON';
export const POST_RENOVATION = 'POST_RENOVATION';
export const NO_POST_RENOVATION = 'NO_POST_RENOVATION';
export const SAME_TIN_AND_TAE = 'SAME_TIN_AND_TAE';
export const DIFFERENT_TIN_AND_TAE = 'DIFFERENT_TIN_AND_TAE';
export const NO_TAE = 'NO_TAE';

export const poeKeys = {
    POST_RENOVATION: {
        SAME_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersPostTextSimplified`,
        DIFFERENT_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersPostText`,
        NO_TAE: `${CONTEXT}-deposits_renewalOffersPostTextNoTae`
    },
    NO_POST_RENOVATION: {
        ROBINSON: {
            SAME_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersTextSimplifiedRobinson`,
            DIFFERENT_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersTextRobinson`,
            NO_TAE: `${CONTEXT}-deposits_renewalOffersTextNoTaeRobinson`
        },
        NO_ROBINSON: {
            SAME_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersTextSimplified`,
            DIFFERENT_TIN_AND_TAE: `${CONTEXT}-deposits_renewalOffersText`,
            NO_TAE: `${CONTEXT}-deposits_renewalOffersTextNoTae`
        }
    },
    postRenovationTag: `${CONTEXT}-deposits_offerPostTag`,
    tag: `${CONTEXT}-deposits_offerTag`,
    lastDayTag: `${CONTEXT}-deposits_offerTagLastDay`,
    button: `${CONTEXT}-deposits_renewalOfferCTA`,
    buttonMultipleOffers: `${CONTEXT}-deposits_renewableOfferCTAMultipleOffers`,
    buttonRemoveOffer: `${CONTEXT}-deposits_removeRenewalOfferPost`,
}